<div class="language-element">
  <span [ngClass]="['flag-icon', countryCode | languageFlagIcon]"></span>
  <span *ngIf="showCountryCode">{{ countryCode | uppercase }}</span>
</div>